import {
  V2Button,
  V2Dialog,
  V2DialogContent,
  V2DialogFooter,
  V2DialogHeader,
} from "@stacklet/ui";

interface Props {
  isOpen: boolean;
  isPending: boolean;
  isEditMode: boolean;
  issueCount: number;
  onCancel: () => void;
  onConfirm: () => void;
}

export function HighIssueCountConfirmationDialog({
  isOpen,
  isPending,
  isEditMode,
  issueCount,
  onCancel,
  onConfirm,
}: Props) {
  const confirmText = isEditMode ? "Yes, update rule" : "Yes, create rule";
  const pendingText = isEditMode ? "Updating..." : "Creating...";

  return (
    <V2Dialog
      isOpen={isOpen}
      onOpenChange={(open) => !open && onCancel()}
      size="md"
    >
      <V2DialogHeader>Confirm high issue volume</V2DialogHeader>
      <V2DialogContent>
        This rule is expected to generate {issueCount} issues. Are you sure you
        want to continue?
      </V2DialogContent>
      <V2DialogFooter>
        <V2Button
          className="border-transparent"
          isDisabled={isPending}
          onPress={onCancel}
          variant="tertiary"
        >
          Cancel
        </V2Button>
        <V2Button
          isDisabled={isPending}
          isPending={isPending}
          onPress={onConfirm}
          pendingText={pendingText}
        >
          {confirmText}
        </V2Button>
      </V2DialogFooter>
    </V2Dialog>
  );
}
